import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MessageService } from '../message.service';
import { NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { RestApiService } from '../rest-api.service';

@Component({
  selector: 'app-top-navbar',
  templateUrl: './top-navbar.component.html',
  styleUrls: ['./top-navbar.component.css']
})
export class TopNavbarComponent implements OnInit, OnDestroy {
  public opened = true;
  public isUserCollapsed = true;
  public isLanCollapsed = true;
  navbarAdmin = [];
  navbarClient = [];
  public userName: string;
  mobileQuery: MediaQueryList;
  respObject: any;
  private eventUrl: string;
  private _mobileQueryListener: () => void;
  copyYear: number;

  // API_URL = 'http://localhost:4200/#';

  // API_URL = 'http://52.25.76.231:9000/#';

  constructor(private _rest: RestApiService, private messageService: MessageService,
    private route: Router, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.messageService.getModuleData().subscribe(modules => {
      let module;
      for (let i = 0; i < modules.length; i++) {
        if (modules[i].path === this.messageService.API_URL + this.eventUrl) {
          console.log(modules[i]);
          module = modules[i].id;
          break;
        }
      }
      // console.log('--->' + this.route.url, window.location.href, location.pathname);
      this._rest.getUserAuthorization({ user_id: this.messageService.getUserId(), module: module }).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          console.log(this.respObject.details);
          this.respObject.details[0].baseflag = true;
          this.messageService.setUserAuth(this.respObject.details);
        } else {

        }
      }, (err) => {

      });
    });
    route.events.subscribe((event) => {

      if (event instanceof NavigationStart) {
        // Show loading indicator
        // console.log('NavigationStart');
      }

      if (event instanceof NavigationEnd) {
        console.log('end : ' + JSON.stringify(event));
        // console.log('NavigationEnd');
        this.eventUrl = event.url;
        this.messageService.getModules();
        this.messageService.getUrl(window.location.href);
        // console.log(JSON.stringify(modules));
        // Hide loading indicator
      }

      if (event instanceof NavigationError) {
        // Hide loading indicator
        // Present error to user
        // console.log(event.error);
      }
    });
  }

  ngOnInit() {
    this.copyYear = new Date().getFullYear();
    this._rest.getAdminModule().subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        for (let i = 0; i < this.respObject.details[0].admin.length; i++) {
          this.respObject.details[0].admin[i].path = this.messageService.API_URL + this.respObject.details[0].admin[i].path;
        }
        for (let i = 0; i < this.respObject.details[0].client.length; i++) {
          this.respObject.details[0].client[i].path = this.messageService.API_URL + this.respObject.details[0].client[i].path;
        }
        this.navbarAdmin = this.respObject.details[0].admin;
        this.navbarClient = this.respObject.details[0].client;
        this.messageService.logOutUrl = this.messageService.API_ROOT
      } else {
      }
    }, (err) => {

    });
    this._rest.getUserdetails(this.messageService.getUserId()).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.userName = this.respObject.details[0].name;
      } else {

      }
    }, function (err) {

    });
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  langCollapse() {
    this.isLanCollapsed = !this.isLanCollapsed;
    this.isUserCollapsed = true;
  }

  userCollapse() {
    this.isUserCollapsed = !this.isUserCollapsed;
    this.isLanCollapsed = true;
  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  // selectedItem(data) {
  //   console.log(JSON.stringify(data));
  // }
  signOut() {
    this.messageService.logOut();
    // window.location.href = this.messageService.API_ROOT;
  }
}
